'use client';
import { Image, Tooltip } from '@nextui-org/react';
import { Tiro_Tamil } from 'next/font/google';
import Link from 'next/link';
import { useCallback, useEffect, useRef, useState } from 'react';
import styles from './bookheader.module.scss';
import { throttle } from '@/utils';
// import { useRouter } from 'next/navigation';

const inter = Tiro_Tamil({
  weight: '400',
  subsets: ['tamil'],
});


interface IProps {
  chapterList: string[];
  urlId: string;
  title: string;
  author: string;
  qa: string[];
  quote: string[];
  page: 'summary' | 'quote' | 'qa';
}

export default function BookHeader(props: IProps) {
  const { title, chapterList, urlId, qa, quote } = props;
  const [isSummaryOPen, setIsSummaryOpen] = useState(false);
  const [isQuoteOpen, setIsQuoteOpen] = useState(false);
  const [isQAOpen, setIsQAOpen] = useState(false);
  const lastScrollTop = useRef(0);

  const [isUp, setIsUp] = useState(true);

  // const router = useRouter();

  const handleScroll = useCallback(throttle(() => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > lastScrollTop.current) {
      setIsUp(false);
    } else {
      setIsUp(true);
    }
    lastScrollTop.current = scrollTop;
  }, 200), [setIsUp]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);

  const summaryList = [
    // {
    //   title: 'Description',
    //   id: 'description',
    // },
    // {
    //   title: 'Readers Also Enjoyed',
    //   id: 'reader-enjoyed',
    // },
    // {
    //   title: 'Author',
    //   id: 'author',
    // },
    // {
    //   title: 'Audiobook',
    //   id: 'audiobook',
    // },
    // {
    //   title: 'Free PDF Download',
    //   id: 'free-pdf',
    // },
    // {
    //   title: 'Summary',
    //   id: 'summary',
    // },
    ...props.chapterList.map(item => {
      return ({
        title: item,
        id: item,
      });
    }),
    // {
    //   title: 'Similar Books',
    //   id: 'similar-books',
    // },
    // {
    //   title: 'Related Book List',
    //   id: 'related-book-list',
    // },
  ];

  const quoteList = [
    ...props.chapterList.map(item => {
      return ({
        title: item,
        id: item,
      });
    }),
    // {
    //   title: 'Related Book Quotes List',
    //   id: 'related-book-list',
    // },
  ];

  const qaList = [
    ...props.chapterList.map(item => {
      return ({
        title: item,
        id: item,
      });
    }),
    // {
    //   title: 'Related Book Q&A List',
    //   id: 'related-book-list',
    // },
  ];
  const handleChapterClick = useCallback((e: React.MouseEvent, target: string) => {
    e.preventDefault();
    setIsQAOpen(false);
    setIsSummaryOpen(false);
    setIsQuoteOpen(false);
    // router.push(target);
    console.log('target');
    window.location.href = target;
  }, [setIsQAOpen, setIsSummaryOpen, setIsQuoteOpen]);

  useEffect(() => {
    const body = document.body;
    if (isSummaryOPen || isQuoteOpen || isQAOpen) {
      body.classList.add('overflow-hidden');
    } else {
      body.classList.remove('overflow-hidden');
    }
  }, [isSummaryOPen, isQuoteOpen, isQAOpen]);

  return (
    <>
      {/* pc */}
      <div className={`max-md:hidden flex items-center justify-center bg-[#00183F] ${ isUp ? styles.showmenu : '' }`}>
        <div className='w-[1280px] h-20 flex'>
          <div className='flex-1 text-[#FFFFFF]'>
            <h2 className={`${inter.className} text-[24px] leading-[34px] pt-[15px]`}>{props.title}</h2>
            <p className={`${inter.className} text-[14px] leading-[20px] pt-1`}>{props.author}</p>
          </div>
          <div className='flex items-center'>
            <Tooltip
              placement='bottom-start'
              isDismissable
              classNames={{
                content: 'rounded-none',
              }}
              content={
                <div className="w-60 max-h-[280px] overflow-auto">
                  {/* <p>All</p> */}
                  {
                    summaryList.map((item, index) => {
                      return (
                        <p className='text-[14px] pt-2 pb-2 px-4 hover:bg-[#F5F5F5]' key={index}>
                          <a className=' hover:text-[#00183F]' href={`/summary/${urlId}#${item.id}`} onClick={(e) => handleChapterClick(e, `/summary/${urlId}#${item.id}`)}>{item.title}</a>
                        </p>
                      );
                    })
                  }
                </div>
              }
            >
              <div className={`${props.page == 'summary' ? 'bg-[#334665]' : ''} text-white text-16-22 flex items-center justify-center w-[156px] h-full`}>
                <span className='pr-1'>Summary</span>
                <Image
                  alt='summary'
                  src='/header-down.png'
                  width={18}
                  height={18}
                  radius='none'
                />
              </div>
            </Tooltip>
            {
              quote.length > 0 ?
                <Tooltip
                  placement='bottom-start'
                  isDismissable
                  classNames={{
                    content: 'rounded-none',
                  }}
                  content={
                    <div className="w-60 max-h-[280px] overflow-auto">
                      {
                        quoteList.map((item, index) => {
                          return (
                            <p className='text-[14px] pt-2 pb-2 px-4 hover:bg-[#F5F5F5]' key={index}>
                              <Link className=' hover:text-[#00183F]' href={`/summary/${urlId}/quote#${item.id}`} onClick={(e) => handleChapterClick(e, `/summary/${urlId}/quote#${item.id}`)}>{item.title}</Link>
                            </p>
                          );
                        })
                      }
                    </div>
                  }
                >
                  <div className={`${props.page == 'quote' ? 'bg-[#334665]' : ''} text-white text-16-22 flex items-center justify-center w-[156px] h-full`}>
                    <span className='pr-1'>Quote</span>
                    <Image
                      alt='summary'
                      src='/header-down.png'
                      width={18}
                      height={18}
                      radius='none'
                    />
                  </div>
                </Tooltip>
                : null
            }
            {
              qa.length > 0 ?
                <Tooltip
                  placement='bottom-start'
                  isDismissable
                  classNames={{
                    content: 'rounded-none',
                  }}
                  content={
                    <div className="w-60 max-h-[280px] overflow-auto">
                      <Link href={`/summary/${urlId}/qa`}>
                      </Link>
                      {
                        qaList.map((item, index) => {
                          return (
                            <p className='text-[14px] pt-2 pb-2 px-4 hover:bg-[#F5F5F5]' key={index}>
                              <Link className=' hover:text-[#00183F]' href={`/summary/${urlId}/qa#${item.id}`} onClick={(e) => handleChapterClick(e, `/summary/${urlId}/qa#${item.id}`)}>{item.title}</Link>
                            </p>
                          );
                        })
                      }
                    </div>
                  }
                >
                  <div className={`${props.page == 'qa' ? 'bg-[#334665]' : ''} text-white text-16-22 flex items-center justify-center w-[156px] h-full`}>
                    <span className='pr-1'>Q&A</span>
                    <Image
                      alt='summary'
                      src='/header-down.png'
                      width={18}
                      height={18}
                      radius='none'
                    />
                  </div>
                </Tooltip>
                : null
            }
          </div>
        </div>

      </div>
      {/* mobile */}
      <div className={ `bg-[#00183F] pb-[10px] px-4 hidden max-md:block ${ isUp ? styles.mobileshow : '' }` }>
        <p className={`${inter.className} text-white text-16-22 text-center py-3`}>{title}</p>
        <div className='flex justify-around'>
          <Tooltip
            placement='bottom-start'
            isOpen={isSummaryOPen}
            isDismissable={true}
            onOpenChange={(open) => setIsSummaryOpen(open)}
            onClose={() => setIsSummaryOpen(false)}
            classNames={{
              content: 'rounded-none',
            }}
            content={
              <div className="w-60 max-h-[280px] overflow-auto">
                {/* <p>All</p> */}
                {
                  summaryList.map((item, index) => {
                    return (

                      <a className='text-[14px] pt-4 px-4' key={index} href={ `/summary/${urlId}#m-${item.id}` } onClick={(e) => handleChapterClick(e, `/summary/${urlId}#m-${item.id}`)}>
                        <p className=' hover:text-[#00183F]'>{item.title}</p>

                      </a>

                    );
                  })
                }
              </div>
            }
          >
            <div className='text-white text-12-17 flex items-center' onClick={() => setIsSummaryOpen(true)}>
              <span className='pr-1'>Summary</span>
              <Image
                alt='summary'
                src='/header-down.png'
                // removeWrapper
                width={12}
                height={12}
                radius='none'
              />
            </div>
          </Tooltip>
          {
            quote.length > 0 ?
              <Tooltip
                placement='bottom-start'
                isOpen={isQuoteOpen}
                isDismissable
                onOpenChange={(open) => setIsQuoteOpen(open)}
                onClose={() => setIsQuoteOpen(false)}
                classNames={{
                  content: 'rounded-none',
                }}
                content={
                  <div className="w-60 max-h-[280px] overflow-auto">
                    {
                      chapterList.map((item, index) => {
                        return (
                          <a className='text-[14px] pt-4 px-4' key={index} href={ `/summary/${urlId}/quote#m-${item}` } onClick={(e) => handleChapterClick(e, `/summary/${urlId}/quote#m-${item}`)}>
                            <p className='text-[14px] hover:text-[#00183F]'>{item}</p>
                          </a>
                        );
                      })
                    }
                  </div>
                }
              >
                <div className='text-white text-12-17 flex' onClick={() => setIsQuoteOpen(true)}>
                  <span className='pr-1'>Quote</span>
                  <Image
                    alt='summary'
                    src='/header-down.png'
                    removeWrapper
                    width={12}
                    height={12}
                    radius='none'
                  />
                </div>
              </Tooltip>
              : null
          }
          {
            qa.length > 0 ?
              <Tooltip
                placement='bottom-start'
                isOpen={isQAOpen}
                isDismissable
                onOpenChange={(open) => setIsQAOpen(open)}
                onClose={() => setIsQAOpen(false)}
                classNames={{
                  content: 'rounded-none',
                }}
                content={
                  <div className="w-60 max-h-[280px] overflow-auto">
                    {
                      chapterList.map((item, index) => {
                        return (
                          <a className='text-[14px] pt-4 px-4' href={`/summary/${urlId}/qa#m-${item}`} key={index} onClick={(e) => handleChapterClick(e, `/summary/${urlId}/qa#m-${item}`)}>
                            <p className='text-[14px] hover:text-[#00183F]'>{item}</p>
                          </a>
                        );
                      })
                    }
                  </div>
                }
              >
                <div className='text-white text-12-17 flex' onClick={() => setIsQAOpen(true)}>
                  <span className='pr-1'>Q&A</span>
                  <Image
                    alt='summary'
                    src='/header-down.png'
                    removeWrapper
                    width={12}
                    height={12}
                    radius='none'
                  />
                </div>
              </Tooltip>
              : null
          }
        </div>
      </div>
    </>
  );
}
